import '@babel/polyfill';
import Vue from 'vue'
import router from './router';
import { VueHammer } from 'vue2-hammer';

Vue.use(router);
Vue.use(VueHammer);


import App from './App.vue'

Vue.config.productionTip = false

const myApp = new Vue({
  router,
  render: h => h(App)
});

document.addEventListener('DOMContentLoaded', function () {
  myApp.$mount('#app')
})
